import { StyledDeliveryDrawer } from './style';

interface DeliveryDrawerProps {
  isDeliveryDrawerOpen: boolean;
  onDeliveryClose: () => void;
  children?: React.ReactNode;
  id?: string;
  footer?: JSX.Element;
  closeIcon?: React.ReactNode;
}

const DeliveryDrawer = ({
  isDeliveryDrawerOpen,
  onDeliveryClose,
  children,
  id,
  footer,
  closeIcon,
}: DeliveryDrawerProps) => {
  const innerOnClose = () => {
    onDeliveryClose();
  };

  return (
    <StyledDeliveryDrawer
      id={id}
      width={512}
      open={isDeliveryDrawerOpen}
      onClose={innerOnClose}
      footer={footer}
      closeIcon={closeIcon}
    >
      {children}
    </StyledDeliveryDrawer>
  );
};

export default DeliveryDrawer;
